import { domainServer } from "../constant";
import AxiosClient from "./axios";

const axiosServer = new AxiosClient(domainServer);

export default axiosServer.axiosClient;
